if (!customElements.get("product-recently-viewed")) {
    class ProductRecentlyViewed extends HTMLElement {
        constructor() {
            super();
        }

        /**
         * Invoked each time one of the custom element's attributes is added, removed, or changed
         */
        attributeChangedCallback() {
            this.rendered = false;
            this.html = undefined;
            this.init();
        }

        /**
         * Runs when element is created
         */
        connectedCallback() {
            if (!this.rendered) {
                this.init();
            }
        }

        /**
         * Initialize state data
         */
        setupData() {
            this.data = {
                productToShow: this.getAttribute("productToShow") || 9999,
            };
        }

        /**
         * Initialize data
         */
        init() {
            this.setupData();
            this.render();

            this.rendered = true;
        }

        /**
         * Based on file `search.recently-viewed.liquid` to get HTML json
         *
         * @param list
         * @returns {Promise<any>}
         */
        async renderProductHTML(list) {
            try {
                let ids = list.map((item) => {
                    return item.id;
                });

                let productIds = list.map((item) => {
                    return `(id:"${item.id}")`;
                });

                let queryString = Array.from(new Set(productIds)).join(" OR ");

                if (list.length > 0) {
                    return await fetch(`${window.origin}/search?view=recently-viewed&product_ids=` + ids.join("-") + "&type=product&q=" + queryString, {
                        credentials: "same-origin",
                        method: "GET",
                    })
                        .then((response) => response.json())
                        .then((data) => {
                            if (data.items && data.items.length) {
                                let html = "";
                                let itemData = data.items.filter((item) => item);

                                ids.forEach((id) => {
                                    let productCard = itemData.find((productItem) => productItem.id == id);
                                    if (productCard) {
                                        html += productCard.html;
                                    }
                                });

                                return {
                                    listHtml: html,
                                    total: data.total,
                                };
                            }
                        });
                }
            } catch (e) {
                console.log(e);
            }
        }

        /**
         * Render HTML
         */
        render() {
            // Invoked at most once after being added
            if (typeof this.html === "undefined") {
                const productData = JSON.parse(localStorage.getItem("recentlyViewedProduct"));
                if (productData && productData.length) {
                    this.renderProductHTML(productData.slice(-this.data.productToShow).reverse()).then((data) => {
                        if (!data || !data.listHtml) return;
                        this.html = data.listHtml;
                        const content = this.querySelector('[data-js="content"]');
                        content.innerHTML = data.listHtml;
                    });
                } else {
                    document.querySelector('[data-layout="recently-viewed"]').style.display = 'none';
                }
            }
        }
    }

    customElements.define("product-recently-viewed", ProductRecentlyViewed);
}
